import _toFinite from 'lodash/toFinite'
import _omitBy from 'lodash/omitBy'
import _isUndefined from 'lodash/isUndefined'
import _isObject from 'lodash/isObject'
import _trim from 'lodash/trim'
import _String from 'lodash/toString'

/* eslint-disable import/prefer-default-export -- single-purpose mapper module */
/** Maps legacy CREATE_SERVER_EVENT `payload.event` to GraphQL `EventName` string */
const SERVER_EVENT_TO_EVENT_LOG_EVENT_NAME = {
  PageView: 'PageViewed',
  Lead: 'UserLead',
  InitiateCheckout: 'UserInitiatedCheckout',
  Purchase: 'UserPurchase',
  user_purchased_free_trial: 'UserPurchasedFreeTrial',
  user_purchased_direct_to_paid: 'UserPurchasedDirectToPaid',
  ViewContent: 'ContentViewed',
}

/**
 * Builds Event Log GraphQL input from a CREATE_SERVER_EVENT action payload.
 * @param {{ event?: string, data?: object }} payload
 * @param {{ testId?: string }} [options]
 * @returns {object|null} EventLog-shaped plain object, or null if event is unknown
 */
export function buildServerEventLogInput (payload, options = {}) {
  if (!payload || !_isObject(payload)) {
    return null
  }
  const legacyEvent = payload.event
  const eventName = SERVER_EVENT_TO_EVENT_LOG_EVENT_NAME[legacyEvent]
  if (!eventName) {
    return null
  }

  const caps = _isObject(payload.data) ? payload.data : {}
  const inner = _isObject(caps.data) ? caps.data : {}

  // GraphQL `price` is a Float; checkout often sends a string (e.g. "12.5").
  // Skip `''`: empty string coerces to 0 via `toFinite`, which would be wrong here.
  // `toFinite` returns `undefined` for invalid input, so we omit `price` from the payload.
  const price = inner.price != null && inner.price !== ''
    ? _toFinite(inner.price)
    : undefined

  const dataInner = _omitBy({
    fbp: caps?.fbp,
    fbc: caps?.fbc,
    externalId: inner?.externalId,
    email: inner?.email,
    currency: inner?.currency,
    ...(price !== undefined ? { price } : {}),
    orderId: inner?.orderId != null && _trim(_String(inner?.orderId)) !== ''
      ? _String(inner?.orderId)
      : undefined,
  }, _isUndefined)

  const testIdStr = options.testId != null ? _trim(_String(options.testId)) : ''
  const trimmedTestId = testIdStr !== '' ? testIdStr : undefined

  const input = _omitBy({
    eventName,
    eventSourceUrl: caps?.eventSourceUrl,
    actionSource: caps?.actionSource,
    eventId: caps?.eventId != null && _trim(_String(caps?.eventId)) !== ''
      ? _String(caps?.eventId)
      : undefined,
    testId: trimmedTestId,
    data: Object.keys(dataInner).length > 0 ? dataInner : undefined,
  }, _isUndefined)

  return input
}
